export const topics = [
  {
    id: "summer-lineup-2026",
    title: "暑期档剧集口碑盘点：从开分到收官",
    categoryId: "film-tv",
    category: "影视热剧",
    summary:
      "把今年暑期档讨论度最高的几部剧按播出顺序排好，从开分争议到收官口碑，看点、名场面和观众评价一次看够。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20amber%20toned%20vintage%20cinema%20seats%20with%20soft%20projector%20light%20and%20film%20reels%2C%20editorial%20photography%2C%20simple%20uncluttered%20background%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=800&seq=guanji-topic-filmset-01&orientation=landscape",
    date: "2026-08-28",
    readTime: "8 分钟",
    views: "18.6万",
    tags: ["剧集", "口碑", "暑期档"],
    highlights: [
      { time: "开播周", text: "首集节奏偏慢，观众对主线铺垫的评价出现分歧。" },
      { time: "第三周", text: "关键配角出场，讨论度快速上升，名场面开始被反复剪辑。" },
      { time: "收官周", text: "结局收束完整，口碑回暖，成为暑期档讨论度最高的一部。" },
    ],
    sections: [
      {
        heading: "为什么值得回看",
        paragraphs: [
          "暑期档剧集往往扎堆上线，单条热搜很难说清一部剧到底好不好看。我们把同档期的作品放进同一条专题里横向对比，你能直接看到每部剧开分前后的变化。",
          "专题按照播出顺序整理，先看整体口碑走向，再跳到具体名场面，不用在多个平台之间反复切换。",
        ],
      },
      {
        heading: "三个绕不开的名场面",
        paragraphs: [
          "第一处出现在主角与旧友重逢的雨中长镜头，被观众称为整部剧的情绪转折点，也是二创素材里出现频率最高的片段。",
          "第二处是配角团在旧厂房里的群像戏，节奏轻快，弹幕密度明显抬升。第三处则是收官前夜的长篇独白，把前面埋下的线索一次性接住。",
        ],
      },
      {
        heading: "整理方式说明",
        paragraphs: [
          "本专题所有看点都标注对应的时间节点，方便你按顺序补看。涉及观众评价的部分只做汇总，不替任何一方下结论。",
        ],
      },
    ],
  },
  {
    id: "film-festival-awards",
    title: "影展红毯与获奖名单目录",
    categoryId: "film-tv",
    category: "影视热剧",
    summary:
      "红毯造型、入围片单、现场发言与获奖结果，按奖项类别整理成一份可以顺着看的目录。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20red%20carpet%20scene%20at%20dusk%20with%20soft%20golden%20lighting%20and%20blurred%20crowd%2C%20editorial%20photography%2C%20warm%20neutral%20background%2C%20high%20detail&width=1200&height=800&seq=guanji-topic-filmfest-02&orientation=landscape",
    date: "2026-07-15",
    readTime: "6 分钟",
    views: "9.4万",
    tags: ["影展", "红毯", "获奖名单"],
    highlights: [
      { time: "开幕日", text: "主竞赛单元片单公布，几部小众作品意外进入讨论中心。" },
      { time: "颁奖夜", text: "最佳剧本与最佳摄影的归属打破了此前的预测。" },
      { time: "次日", text: "现场问答环节的视频被大量转发。" },
    ],
    sections: [
      {
        heading: "红毯看点怎么整理",
        paragraphs: [
          "红毯部分不做排名，只按出场顺序归档，把造型风格相近的放在一起，方便比较同一种审美的不同处理方式。",
          "每位嘉宾的造型都标注了色彩主调，避免“最好看”这类主观判断，把描述留给画面本身。",
        ],
      },
      {
        heading: "获奖名单的阅读顺序",
        paragraphs: [
          "名单按照主竞赛、评审团、技术类奖项分组呈现，先看关注度最高的几个奖项，再往下看技术与短片单元。",
        ],
      },
    ],
  },
  {
    id: "tour-live-moments",
    title: "巡演现场名场面合集：安可与大合唱",
    categoryId: "music-live",
    category: "音乐现场",
    summary:
      "把一轮巡演里被反复回放的现场瞬间按城市整理，安可曲目、全场大合唱与临场改编都在这里。",
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20orange%20stage%20lights%20and%20silhouette%20of%20crowd%20hands%20raised%2C%20editorial%20music%20photography%2C%20dark%20warm%20background%20with%20strong%20contrast&width=1200&height=800&seq=guanji-topic-concert-03&orientation=landscape",
    date: "2026-09-02",
    readTime: "7 分钟",
    views: "14.2万",
    tags: ["巡演", "现场", "大合唱"],
    highlights: [
      { time: "首站", text: "开场即换掉原定曲目，改成尚未发布的新歌。" },
      { time: "中场", text: "全场合唱段落被完整记录下来，成为本轮巡演传播最广的一段。" },
      { time: "安可", text: "追加了一首多年未在现场演出的旧作。" },
    ],
    sections: [
      {
        heading: "按城市顺序看",
        paragraphs: [
          "同一首歌在不同城市的现场处理并不一样，专题把同一曲目的多个版本并排放在一起，能听出即兴改编的差别。",
          "每段记录都标注了所在城市与场次，方便你找到自己关注的那一场。",
        ],
      },
      {
        heading: "安可环节的整理逻辑",
        paragraphs: [
          "安可曲目单独成组，因为这部分最能反映现场的临场状态。我们把返场前的等待时间也一并记录，现场的紧张感因此更完整。",
        ],
      },
    ],
  },
  {
    id: "stage-comeback-cut",
    title: "舞台直拍与回归打歌合集",
    categoryId: "music-live",
    category: "音乐现场",
    summary:
      "回归期的每一场打歌舞台按播出顺序整理，直拍机位、造型变化与编舞调整都做了标注。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20performance%20stage%20with%20warm%20spotlights%20and%20light%20smoke%2C%20minimalist%20backdrop%2C%20editorial%20concert%20photography%2C%20amber%20tones&width=1200&height=800&seq=guanji-topic-stage-04&orientation=landscape",
    date: "2026-06-21",
    readTime: "5 分钟",
    views: "11.7万",
    tags: ["舞台", "直拍", "回归"],
    highlights: [
      { time: "首场", text: "编舞版首次公开，走位与预告版本有细微差别。" },
      { time: "第二周", text: "造型更换，舞台灯光方案同步调整。" },
      { time: "末场", text: "加入了此前未出现的即兴段落。" },
    ],
    sections: [
      {
        heading: "直拍机位对照",
        paragraphs: [
          "同一场舞台往往有多个机位，专题把不同机位的画面并列，方便比较编舞细节与镜头语言。",
        ],
      },
      {
        heading: "造型与灯光变化",
        paragraphs: [
          "回归期通常会准备多套造型，专题按场次标注每一场的服装主色，配合灯光方案一起看，舞台的层次会更清楚。",
        ],
      },
    ],
  },
  {
    id: "variety-season-highlights",
    title: "综艺整季名场面一次看够",
    categoryId: "variety",
    category: "综艺名场面",
    summary:
      "一整季的笑点、反转与高光片段按集数排好，跳过冗长铺垫，直接看到值得回放的部分。",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20television%20studio%20set%20with%20warm%20studio%20lights%20and%20colorful%20props%2C%20editorial%20photography%2C%20clean%20simple%20background&width=1200&height=800&seq=guanji-topic-variety-05&orientation=landscape",
    date: "2026-05-30",
    readTime: "6 分钟",
    views: "13.5万",
    tags: ["综艺", "名场面", "整季"],
    highlights: [
      { time: "第 2 期", text: "嘉宾组合意外产生化学反应，成为整季讨论起点。" },
      { time: "第 6 期", text: "游戏环节的一次反超被剪成名场面。" },
      { time: "收官期", text: "回顾剪辑串起整季高光，情绪集中释放。" },
    ],
    sections: [
      {
        heading: "怎么跳过铺垫",
        paragraphs: [
          "综艺单期时长较长，专题把每期的关键时间点提炼出来，你只需要按标注的时间跳转，就能看完整季的精华。",
        ],
      },
      {
        heading: "收录标准",
        paragraphs: [
          "只收录当期弹幕与讨论明显集中的片段，不按嘉宾热度排序，保证目录的客观性。",
        ],
      },
    ],
  },
  {
    id: "weekly-trend-digest",
    title: "本周网络热梗与讨论合集",
    categoryId: "trending",
    category: "网络热议",
    summary:
      "把一周内传播最广的梗、话题和讨论方向整理成目录，标注起源与扩散路径，一次看清来龙去脉。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20waves%20representing%20digital%20trends%2C%20minimal%20editorial%20illustration%2C%20cream%20background%2C%20soft%20shapes&width=1200&height=800&seq=guanji-topic-trend-06&orientation=landscape",
    date: "2026-09-06",
    readTime: "5 分钟",
    views: "21.3万",
    tags: ["热梗", "周报", "讨论"],
    highlights: [
      { time: "周一", text: "一个生活类梗从短视频平台扩散到全站。" },
      { time: "周三", text: "话题方向从娱乐转向实用讨论。" },
      { time: "周末", text: "相关二创集中出现，热度到达顶点后自然回落。" },
    ],
    sections: [
      {
        heading: "热梗为什么会传播",
        paragraphs: [
          "一个梗能不能扩散，通常取决于它是否容易模仿。专题会标注每个梗的“使用门槛”，门槛越低，传播往往越快。",
        ],
      },
      {
        heading: "讨论方向的转折",
        paragraphs: [
          "很多话题会在一周内改变讨论重心，专题用时间线记录这种转折，让你看清一个话题是怎么从 A 变成 B 的。",
        ],
      },
    ],
  },
  {
    id: "launch-event-recap",
    title: "新品发布会看点合集",
    categoryId: "trending",
    category: "网络热议",
    summary:
      "把发布会上的关键发布、参数变化与现场反应按环节整理，省去冗长串场，直接看重点。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20product%20launch%20stage%20with%20warm%20lighting%20and%20large%20screen%2C%20minimalist%20conference%20hall%2C%20editorial%20photography%2C%20warm%20neutral%20tones&width=1200&height=800&seq=guanji-topic-launch-07&orientation=landscape",
    date: "2026-08-19",
    readTime: "6 分钟",
    views: "8.8万",
    tags: ["发布会", "看点", "复盘"],
    highlights: [
      { time: "开场", text: "发布节奏比往年更快，前半段密集放出更新。" },
      { time: "中段", text: "价格公布环节成为全场讨论焦点。" },
      { time: "结尾", text: "一段未预告的演示引发后续大量讨论。" },
    ],
    sections: [
      {
        heading: "参数怎么读",
        paragraphs: [
          "发布会往往用对比手法呈现参数，专题把同类产品的数据并列，避免只看到涨幅而忽略基数。",
        ],
      },
      {
        heading: "现场反应的价值",
        paragraphs: [
          "现场观众的反应能反映信息密度，专题记录了掌声与安静的时间点，帮助你判断哪一段最值得回看。",
        ],
      },
    ],
  },
  {
    id: "finals-key-possession",
    title: "决赛夜关键回合复盘合集",
    categoryId: "sports",
    category: "体育赛场",
    summary:
      "按节次整理决赛的关键回合，比分变化、战术调整与临场换人都做了标注，一次看完比赛走向。",
    cover:
      "https://readdy.ai/api/search-image?query=basketball%20arena%20under%20warm%20arena%20lights%20with%20empty%20court%2C%20editorial%20sports%20photography%2C%20simple%20background%2C%20dramatic%20lighting&width=1200&height=800&seq=guanji-topic-finals-08&orientation=landscape",
    date: "2026-06-14",
    readTime: "7 分钟",
    views: "10.1万",
    tags: ["决赛", "复盘", "关键回合"],
    highlights: [
      { time: "首节", text: "双方节奏都偏慢，比分紧咬。" },
      { time: "第三节", text: "一次连续得分改变了场上的攻防选择。" },
      { time: "末节", text: "暂停后的战术执行成为胜负分水岭。" },
    ],
    sections: [
      {
        heading: "比分之外看什么",
        paragraphs: [
          "比分只能反映结果，专题额外标注了双方的轮换与体能分配，帮助理解第四节节奏下降的原因。",
        ],
      },
      {
        heading: "关键回合的筛选",
        paragraphs: [
          "只保留真正改变比赛走向的回合，进球集锦不在收录范围内，避免目录变成单纯的高光合集。",
        ],
      },
    ],
  },
  {
    id: "city-night-market-map",
    title: "城市夜宵地图盘点",
    categoryId: "life",
    category: "生活趣闻",
    summary:
      "按城市整理夜宵聚集地，标注营业时段与人流规律，把烟火气最足的时段一次排清楚。",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20street%20food%20night%20market%20with%20warm%20lantern%20light%2C%20editorial%20documentary%20photography%2C%20simple%20warm%20background&width=1200&height=800&seq=guanji-topic-nightmarket-09&orientation=landscape",
    date: "2026-04-27",
    readTime: "5 分钟",
    views: "7.6万",
    tags: ["夜宵", "城市", "地图"],
    highlights: [
      { time: "晚 8 点", text: "刚开摊，人流稀疏，适合想慢慢逛的人。" },
      { time: "晚 10 点", text: "进入高峰，热门摊位开始排队。" },
      { time: "凌晨 1 点", text: "人流回落，部分摊主会临时加点隐藏菜单。" },
    ],
    sections: [
      {
        heading: "时段比地点更重要",
        paragraphs: [
          "同一条街在不同时段完全是两种体验，专题按小时标注人流变化，你可以按自己的节奏选择抵达时间。",
        ],
      },
      {
        heading: "关于收录",
        paragraphs: [
          "本专题只整理公开可查的街区信息与时段规律，不涉及具体商家的评价排名，保持目录的中立性。",
        ],
      },
    ],
  },
];